import React from "react";
import Box from "react-raster";
import { theme } from "src/config";
import styled from "styled-components";

export interface IBadgeProps {
  children?:    React.ReactNode;
  content?:     React.ReactNode;
  className?:   string;
  color?:       string;
  borderColor?: string;
  top?:         string;
  right?:       string;
  left?:        string;
  width?:       string;
  height?:      string;
  border?:      string;
}

export const StyledBadge = styled.div<IBadgeProps>`
  position:        absolute;
  top:             ${(p) => p.top || "-0.2rem"};
  right:           ${(p) => p.right || "-0.4rem"};
  left:            ${(p) => p.left};
  min-width:       ${(p) => p.width || "1.4rem"};
  max-width:       fit-content;
  height:          ${(p) => p.height || "1.4rem"};
  font-weight:     ${theme.font.weight.bold};
  font-size:       ${theme.font.size.small};
  background:      ${(p) => p.color || `${theme.color.slate11}`};
  color:           ${theme.color.white};
  display:         flex;
  justify-content: center;
  align-items:     center;
  border-radius:   50%;
  border:          ${(p) => p.border || "1px"} solid;
  border-color:    ${(p) => p.borderColor || `${theme.color.white}`};
  pointer-events:  none;
`

export const Badge = ({ children, content, border, color, borderColor, top, right, height, width, ...props}: IBadgeProps): JSX.Element => {

  return (
    <Box>
      {React.Children.map(children, (child) => child)}
      <StyledBadge height={height} width={width} top={top} right={right} borderColor={borderColor} color={color} border={border} {...props}>{content}</StyledBadge>
    </Box>
  );
};
